// engineDecision.js — F13-E13-T04: decisão de motor POR TAREFA, não por toggle.
// @arch:pure-engine
//
// O role-scaffold (Thinker→Worker) vivia atrás de um flag global DEFAULT OFF —
// a nota do Thinker nunca alcançava o Worker em runs normais. Conceito-alvo
// (Claude Code): o pré-pensamento é decidido pela COMPLEXIDADE da tarefa, não
// por configuração. Task simples segue direto pro Worker (custo zero); task
// complexa (multi-arquivo/feature/acceptance formal) ganha o Thinker.

import { looksLikeComplexTask } from '../codeAgentMode.js';

/** Task de DAG que se beneficia de um pré-pensamento (Thinker). Pure. */
export function shouldThinkForTask(task) {
  if (!task || typeof task !== 'object') return false;
  if (task.acceptance && String(task.acceptance).trim()) return true;
  return looksLikeComplexTask(String(task.name || task.goal || ''));
}

/** O DAG precisa do scaffold? Flag global ON, ou ≥1 task complexa. Pure. */
export function dagWantsScaffold(dagTasks, flagOn) {
  if (flagOn) return true;
  return Array.isArray(dagTasks) && dagTasks.some(shouldThinkForTask);
}

/** Envelopa o assign: com o flag OFF, só task complexa ganha papéis (Thinker);
 * task simples devolve {} → o scaffold degrada pra Worker puro. Pure. */
export function roleAssignForTask(baseAssign, flagOn) {
  return (task) => {
    if (!flagOn && !shouldThinkForTask(task)) return {};
    return typeof baseAssign === 'function' ? (baseAssign(task) || {}) : (baseAssign || {});
  };
}
